import { APIConfig } from 'reactApp/api/APIConfig';

import { jsonp } from './jsonp';

class SDCAPICall {
    _method = 'sdc';
    _type = 'jsonp';

    constructor({ error }) {
        this.error = error;
    }

    makeRequest() {
        return new Promise((resolve, reject) => {
            const { protocol, host } = window.location;
            const { requestUrl } = this.error;
            const authDomain = APIConfig.get('auth-domain');

            jsonp(
                `${authDomain}sdc?from=${encodeURIComponent(`${protocol}//${host}${requestUrl}`)}`,
                () => {
                    resolve();
                },
                () => {
                    reject(this.error);
                }
            );
        });
    }
}

export { SDCAPICall };
